import { type CloudQueueController } from '@/cloudQueue/CloudQueueController'
import {
    createDisposer,
    createLogPrefix,
    type Disposable,
    type LogTarget,
} from '@amazon/vinyl-util'
import { BridgeDelegate, type BridgeDelegateOptions } from '@/bridge/BridgeDelegate'

/**
 * When the queue is set, transmits over the bridge for the receiver to begin playback.
 */
export class BridgedCloudQueueController implements CloudQueueController, LogTarget, Disposable {
    logPrefix = createLogPrefix('BridgedCloudQueueController')

    readonly setQueue: CloudQueueController['setQueue']
    readonly seekToEntry: CloudQueueController['seekToEntry']
    readonly refetchQueue: CloudQueueController['refetchQueue']

    private readonly disposer = createDisposer()

    constructor(options: BridgeDelegateOptions<CloudQueueController>) {
        const { add } = this.disposer
        const bridgeDelegate = add(new BridgeDelegate<CloudQueueController>(options))
        this.setQueue = bridgeDelegate.createCommand('setQueue')
        this.seekToEntry = bridgeDelegate.createCommand('seekToEntry')
        this.refetchQueue = bridgeDelegate.createAsyncCommand('refetchQueue')
    }

    dispose(): void {
        this.disposer.dispose()
    }
}
